import React, { useState, useCallback } from 'react'
import { Button, Popover } from 'antd'
import { Users } from 'lucide-react'
import { useStakeholderContext } from '../../../../../features/stakeholder'
import { useCharacterModal } from '../../../../../context/CharacterModalContext'
import { TeamDropdownContent } from '../../TeamDropdown'
import { StyledButtonWrapper, ButtonText } from '../../styles/MindMapHeaderStyles'
import { MobileTooltip } from './MobileTooltip'

export const TeamButton: React.FC = () => {
  const { projectStakeholders } = useStakeholderContext()
  const characterModal = useCharacterModal()
  const [popoverOpen, setPopoverOpen] = useState(false)

  const hasTeamMembers = projectStakeholders.length > 0

  const handleClick = useCallback(() => {
    if (hasTeamMembers) {
      setPopoverOpen(true)
    } else {
      characterModal.openModal()
    }
  }, [hasTeamMembers, characterModal])

  const handleOpenCharacterModal = useCallback(
    (selectedTemplateId?: string) => {
      characterModal.openModal(selectedTemplateId)
    },
    [characterModal]
  )

  if (hasTeamMembers) {
    return (
      <MobileTooltip title="Simulated team">
        <Popover
          content={
            <TeamDropdownContent
              onClose={() => setPopoverOpen(false)}
              onOpenCharacterModal={handleOpenCharacterModal}
            />
          }
          trigger="click"
          placement="bottomRight"
          open={popoverOpen}
          onOpenChange={setPopoverOpen}
          styles={{ body: { background: 'var(--color-bg-elevated)', padding: 0 } }}
        >
          <StyledButtonWrapper>
            <Button type="default" icon={<Users size={16} />}>
              <ButtonText>Simulated team</ButtonText>
            </Button>
          </StyledButtonWrapper>
        </Popover>
      </MobileTooltip>
    )
  }

  return (
    <MobileTooltip title="Simulated team">
      <StyledButtonWrapper>
        <Button type="default" icon={<Users size={16} />} onClick={handleClick}>
          <ButtonText>Simulated team</ButtonText>
        </Button>
      </StyledButtonWrapper>
    </MobileTooltip>
  )
}
